// Badge Component
export default function Badge(props) {
  return <button className="badge">{props.value}</button>;
}
